const INTERNAL_MODEL_NAMES = [
  /image[\s_-]?2/gi,
  /\bdfai\b/gi,
  /\bppt\s*master\b/gi,
  /(?:codex|chatgpt|openai|gpt(?:[-_. ]?[a-z0-9]+)*|claude(?:[-_. ]?[a-z0-9]+)*|gemini(?:[-_. ]?[a-z0-9]+)*|deepseek(?:[-_. ]?[a-z0-9]+)*|qwen(?:[-_. ]?[a-z0-9]+)*|doubao(?:[-_. ]?[a-z0-9]+)*|hunyuan(?:[-_. ]?[a-z0-9]+)*|glm(?:[-_. ]?[a-z0-9]+)*)/gi,
];

const USER_FACING_ERROR_TEMPLATES: Array<{ pattern: RegExp; code: string; message: string }> = [
  { pattern: /codex_rate_limit_window|rate_limit_error|rate[\s_-]*limit|限流窗口|请求过于频繁|HTTP\s*429/i, code: "E1001", message: "生成服务当前繁忙，请稍后重试。" },
  { pattern: /insufficient[_\s-]*quota|quota[_\s-]*exceeded|额度不足|配额不足/i, code: "E1002", message: "生成服务额度暂时不足，请联系管理员。" },
  { pattern: /content[_\s-]*(?:policy|filter)|safety[_\s-]*(?:policy|filter)|内容审核|安全策略|违规内容/i, code: "E1003", message: "当前内容未通过安全检查，请调整内容后重试。" },
  { pattern: /timeout|timed out|ETIMEDOUT|UND_ERR_CONNECT_TIMEOUT|请求超时|响应超时/i, code: "E1004", message: "生成服务响应超时，请稍后重试。" },
  { pattern: /invalid[_\s-]*(?:api[_\s-]*key|authentication)|unauthori[sz]ed|authentication|HTTP\s*(?:401|403)|鉴权失败|密钥无效/i, code: "E1005", message: "生成服务配置异常，请联系管理员。" },
  { pattern: /ECONNRESET|ECONNREFUSED|EPIPE|EAI_AGAIN|fetch failed|network|socket|HTTP\s*5\d\d|网络异常|连接失败/i, code: "E1006", message: "生成服务暂时不可用，请稍后重试。" },
];

export function mapGenerationErrorMessage(value: unknown, fallback = ""): string {
  const message = String(value || fallback);
  const template = USER_FACING_ERROR_TEMPLATES.find((candidate) => candidate.pattern.test(message));
  return template ? `${template.message}（错误编号：${template.code}）` : message;
}

export function filterUserFacingGenerationKeywords(value: unknown, fallback = ""): string {
  let message = String(value || fallback);
  message = message
    .replace(/image[\s_-]?2\s*生成/gi, "图片生成")
    .replace(/image[\s_-]?2\s*(?:单页)?修改/gi, "单页修改")
    .replace(INTERNAL_MODEL_NAMES[0], "视觉生成")
    .replace(INTERNAL_MODEL_NAMES[1], "标准生成")
    .replace(INTERNAL_MODEL_NAMES[2], "标准生成")
    .replace(INTERNAL_MODEL_NAMES[3], "生成服务")
    .replace(/当前模型/gi, "当前生成服务")
    .replace(/模型(?:请求|调用)/gi, "生成请求")
    .replace(/模型引用图/gi, "生成参考图")
    .replace(/模型生成/gi, "系统生成")
    .replace(/\bworker\b/gi, "生成服务");
  return message;
}

/** Keeps renderer/model identifiers out of status, error, and chat copy. */
export function userFacingGenerationMessage(value: unknown, fallback = ""): string {
  return filterUserFacingGenerationKeywords(mapGenerationErrorMessage(value, fallback), fallback);
}

export function userFacingGenerationErrorCode(value: unknown): string {
  const code = String(value || "").trim();
  if (!code) return "";
  if (/codex_rate_limit_window|rate[_-]*limit|429/i.test(code)) return "E1001";
  if (/quota/i.test(code)) return "E1002";
  if (/content[_-]*(?:policy|filter)|safety[_-]*(?:policy|filter)/i.test(code)) return "E1003";
  if (/timeout|timedout|timed_out|ETIMEDOUT/i.test(code)) return "E1004";
  if (/auth|api[_-]*key|401|403/i.test(code)) return "E1005";
  if (/network|connection|upstream|5\d\d/i.test(code)) return "E1006";
  const filtered = filterUserFacingGenerationKeywords(code, "generation_service_error");
  return filtered === code ? code : "E1099";
}
